
// Generated by dayjs-nuxt-module
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'

import 'dayjs/locale/zh-cn'
import 'dayjs/locale/zh-cn'
import relativeTime from 'dayjs/plugin/relativeTime'
import duration from 'dayjs/plugin/duration'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import utc from 'dayjs/plugin/utc'


dayjs.extend(updateLocale)

dayjs.extend(relativeTime)
dayjs.extend(duration)
dayjs.extend(advancedFormat)
dayjs.extend(utc)



// defaultLocale: "zh-cn"


dayjs.updateLocale("zh-cn")
dayjs.locale('zh-cn')


export default dayjs
